import { Tab } from '@models/classes';
import { TabProps } from '@models/classes/models';

export const tabPropsToTabs = (props: TabProps[]): Tab[] =>
  props.map(({ guards = [], ...prop }: TabProps) =>
    new Tab(prop).addGuards(guards, '/'),
  );
